export default "__VITE_ASSET__C8ChN$XR__"